import { config } from '../../store/config';
import { ui } from '../../store/ui';
import {
  EVO_WRAPPER_INIT_SUBTYPE,
  EVO_WRAPPER_MESSAGE_TYPE,
  EVO_WRAPPER_TOGGLE_FULLSCREEN_SUBTYPE,
} from '../constants';

export function handleEvoWrapperMessages(event, store) {
  const { data: message } = event;
  const { dispatch } = store;

  if (message?.type !== EVO_WRAPPER_MESSAGE_TYPE) return;

  switch (message?.subType) {
  case EVO_WRAPPER_INIT_SUBTYPE: {
    dispatch(config.update({ isEvoWrapped: true }));

    /**
     * As @ezugi/hooks are not connected to the store
     * we need to do this in order to know inside the hook if we are dealing
     * with a wrapped game
     */
    window.__EZUGI_EVO_WRAPPER__ = true;

    /**
     * Evolution has its own enable/disable configs for fullscreen, tipping, etc
     * we receive the config boolean from Evo's system, and then we overwrite our own config
     * for wrapped games
     */
    const { config: { widgets } } = message.payload;
    dispatch(config.update({ widgets }));
    break;
  }

  case EVO_WRAPPER_TOGGLE_FULLSCREEN_SUBTYPE:
    /**
     * We compare the fullscreen state of Evo's wrapper with our own
     * Necessary when user presses ESC button to exit fullscreen on wrapped games
     * We need to keep both states in sync (Wrapper's fullscreen and Ezugi Game Fullscreen)
     */
    dispatch(ui.update({ isParentWindowFullscreen: message.payload.isFullscreen }));
    break;

  default:
    /* eslint-disable-next-line no-console */
    console.warn(`Unhandled message: ${message?.subType}`);
    break;
  }
}
